export default {"src":"/uk/_next/static/media/error-icon.9d657b49.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};